<template>
    <div>
        <div class="page-title">{{ module.title }}
            <button class="btn btn-new" @click="editItem(null)">创建新项目</button>
        </div>
        
        <div class="flex flex-left-center" v-if="module">
            <confirm-radio-group
                :origin-value="module[module['ek']]"
                title="模块"
                :options="modulusOptions.enabled"
                @change="value => courseConfigSave(module['ek'], value)"
            ></confirm-radio-group>
            
            <template v-if="module['group'] !== 'courses' ">
                
                <span class="radio-sp"></span>
                
                <confirm-radio-group
                    :origin-value="module[module['listKey']]"
                    title="布局"
                    :options="modulusOptions.listStyle"
                    @change="value => courseConfigSave(module['listKey'], value)"
                ></confirm-radio-group>
                
                <span class="list-demo-btn" @click="showCourseTipsImage">👉手机布局效果示例</span>
                
            </template>
        </div>
        
        <div v-if="listLoading" class="loading-block">
            <loader/>
        </div>
        <div v-else-if="!list || !list.length" class="loading-block">
            <p>{{ module.empty }}</p>
            <button class="btn btn-new" @click="editItem(null)">创建新项目</button>
        </div>
        <div class="st-list" v-else>
            
            <ca-item
                v-for="(item,lk) in list"
                :key="lk"
                class="st-list-item"
                :item="item"
                @qrcode="qrcodeItem"
                @edit="editItem"
                @poster="editPoster"
            />
            
            <div>
                <a-pagination
                    class="st-pagination"
                    v-if="pager.total > 0 "
                    :current="pager.current"
                    :total="pager.total"
                    :page-size="pager.size"
                    :show-total="(total, range) => `${range[0]}-${range[1]},共${total}条数据`"
                    @change="gotoPage"
                />
            </div>
        </div>
        
        
        <detail
            @success="getList"
            v-model="showDetailModal"
            :group="module.group"
            :item="detailItem"
            :share-enabled="app.course_share"
        />
        
        <a-modal width="380px" v-model="showMiniQrcodeModal" title="详情页快速码下载(用于宣传物料设计)" :footer="null">
            <div class="text-center mini-qrcode">
                <img style="width: 180px" v-if="miniQrcodeUrl" :src="miniQrcodeUrl" alt="">
            </div>
            <div class="qrcode-btns">
                <at-input v-model="miniQrcodeMemberId" class="mb-4" placeholder="请输入推荐人ID"/>
                <a v-if="detailItem" @click="download" class="btn mb-4">下载推广直达码</a>
                <div>
                    <small>主理人填入推荐人ID 后，下载推广直达码。包含该推荐关系二维码</small>
                </div>
            </div>
        </a-modal>
        
        <img v-if="miniQrcodeUrl" class="preload-img" @load="qrcodeReady" :src="miniQrcodeUrl" alt="">
        
        <poster-modal
            v-model="showPosterModal"
            :defaultBackground="posterItem.background"
            :defaultQrcode="posterItem.qrcode"
            @submit="handlePosterSubmit"
            @clean="handlePosterClean"
        ></poster-modal>
    </div>
</template>

<script>

import Detail from "./Detail";
import Loader from "../../../components/Loader";
import CaItem from "./com/CaItem";
import api from "../../../repo/api";
import axios from "axios";
import auth from "@/auth";
import AtInput from "@/components/AtInput.vue";
import PosterModal from "@/components/PosterModal.vue"
import ConfirmRadioGroup from "@/views/AST/Serve/com/ConfirmRadioGroup.vue";

export default {
    name: "Course",
    components: {
        ConfirmRadioGroup,
        AtInput,
        CaItem,
        Loader,
        Detail,
        PosterModal,
    },
    props: {
        app: Object
    },
    data() {
        return {
            showMiniQrcodeModal: false,
            miniQrcodeUrl: "",
            miniQrcodeMemberId: "",
            module: {
                title: '',
                type: '',
                ek: '',
                listKey: '',
                group: '',
                enabled: 1,
                empty: '',
            },
            showDetailModal: false,
            showPosterModal: false,
            detailItem: null,
            listLoading: true,
            pager: {
                defaultCurrent: 1,
                current: 1,
                defaultPageSize: 10,
                total: 1,
                pageSize: 15,
            },
            query: {
                page: 1
            },
            list: [],
            modulusOptions: {
                enabled: [
                    {
                        label: '开启',
                        tips: '开启后该版块对外显示，用户可正常查看',
                        value: 1
                    },
                    {
                        label: '隐藏',
                        tips: '隐藏后该板块不再显示，用户将无法查看',
                        value: 0
                    }
                ],
                listStyle: [
                    {
                        label: '单列',
                        tips: '确定以单列形式展示？',
                        value: 'single'
                    },
                    {
                        label: '双列',
                        tips: '确定以双列形式展示？',
                        value: 'double'
                    }
                ]
            },
            modules: {
                act: {
                    title: '活动介绍设置',
                    empty: '暂无任何活动',
                    ek: 'activity_enabled',
                    listKey: 'activity_list_style',
                    group: 'activity',
                },
                ser: {
                    title: '服务介绍设置',
                    empty: '暂无任何服务',
                    ek: 'serve_enabled',
                    listKey: 'serve_list_style',
                    group: 'serve',
                },
                cla: {
                    title: '课程介绍设置',
                    empty: '暂无任何课程',
                    ek: 'course_enabled',
                    listKey: 'course_list_style',
                    group: 'courses',
                }
            },
            posterItem: {
                background: undefined,
                qrcode: undefined,
            },
        }
    },
    watch: {
        '$route.params.module'() {
            this.init()
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            let md = this.$route.params.module
            let module = this.modules[md]
            
            if (!module) return
            
            this.module.ek = module.ek
            this.module.title = module.title
            this.module.group = module.group
            this.module.listKey = module.listKey || 'single'
            this.module.empty = module.empty
            
            this.getFirstList()
            this.getConfig()
        },
        getConfig() {
            this.configLoading = true
            
            api.get('/course/config', (data) => {
                
                this.configLoading = false
                
                this.module[this.module.ek] = data.data[this.module.ek] ? 1 : 0
                this.module[this.module.listKey] = data.data[this.module.listKey] || 'single'
                
                this.$forceUpdate()
            });
            
        },
        getList() {
            this.listLoading = true
            
            this.query.group = this.module.group
            
            api.get('/course/list', this.query, (data) => {
                
                this.listLoading = false
                
                this.list = data.data.data
                this.pager.current = data.data.current_page
                this.pager.total = data.data.total
                this.pager.size = data.data.per_page
            })
        },
        getFirstList() {
            this.query.page = 1
            this.getList()
        },
        gotoPage(page) {
            this.query.page = page
            this.getList()
        },
        editItem(item) {
            
            if (this.module.group == 'courses') {
                
                let query = {};
                
                if (item) {
                    query.id = item.id;
                }
                
                this.$router.push({
                    path: '/ast/serve/create/courses',
                    query
                })
            } else {
                this.detailItem = item
                this.showDetailModal = true
            }
            
        },
        qrcodeItem(item) {
            
            this.detailItem = item
            
            let url = axios.defaults.baseURL + '/collocation/com/mini-qrcode?';
            
            url += 'token=' + auth.getToken()
            url += '&_mini_app_id=' + auth.appId()
            
            url += '&path=packagesB/serviceDetail/serviceDetail?id=' + item.id;
            
            
            this.miniQrcodeUrl = '';
            
            setTimeout(() => {
                this.miniQrcodeUrl = encodeURI(url);
            }, 50)
            
            this.$loading.show()
        },
        download() {
            this.$loading.show()
            
            api.get('/ast-member/detail', {member_id: this.miniQrcodeMemberId}, (data) => {
                
                this.$loading.hide()
                
                if (data.code !== 0) {
                    return this.$message.data(data);
                }
                
                let url = axios.defaults.baseURL + '/collocation/com/mini-qrcode?';
                
                let path = 'packagesB/serviceDetail/serviceDetail?id=' + this.detailItem.id;
                
                path += '&ref=' + data.data.id
                
                url += 'token=' + auth.getToken()
                url += '&_mini_app_id=' + auth.appId()
                
                url += '&path=' + encodeURIComponent(path);
                
                url += '&name=' + this.detailItem.title + '推广码ID' + data.data.member_id
                
                console.log(encodeURI(url));
                window.open(encodeURI(url))
            });
        },
        qrcodeReady() {
            this.$loading.hide()
            this.showMiniQrcodeModal = true
        },
        showCourseTipsImage() {
            this.$previewImages('https://static.ycsd.work/col/course-tips.png')
        },
        courseConfigSave(key, value) {
            this.$loading.show()
            
            api.post('/course/config', {key, value}, (data) => {
                
                this.$loading.hide()
                
                this.$message.data(data)
                
                if (data.code === 0) {
                    this.module[key] = value
                    this.$forceUpdate()
                }
            })
        },
        editPoster(item) {
            this.showPosterModal = true
            this.detailItem = item
            this.posterItem.background = {}
            this.posterItem.qrcode = {}
            if (item.poster) {
                this.$set(this.posterItem.background, 'imageUrl', item.poster)
            }
            if (item.poster_frame?.background) {
                this.$set(this.posterItem.background, 'w', item.poster_frame.background.w)
                this.$set(this.posterItem.background, 'h', item.poster_frame.background.h)
            }
            if (item.poster_frame?.qrcode) {
                this.$set(this.posterItem.qrcode, 'w', item.poster_frame.qrcode.w)
                this.$set(this.posterItem.qrcode, 'h', item.poster_frame.qrcode.h)
                this.$set(this.posterItem.qrcode, 'l', item.poster_frame.qrcode.l)
                this.$set(this.posterItem.qrcode, 't', item.poster_frame.qrcode.t)
            }
        },
        handlePosterSubmit({background, qrcode}) {
            const reqData = {
                id: this.detailItem.id,
                poster: background.imageUrl,
                poster_frame: {
                    background: {
                        w: background.w,
                        h: background.h,
                    },
                    qrcode: {
                        w: qrcode.w,
                        h: qrcode.h,
                        l: qrcode.l,
                        t: qrcode.t,
                    },
                },
            }
            api.postCourseUpdatePosterInfo(reqData, (resData) => {
                if (resData.code === 0) {
                    this.$message.success("成功")
                    setTimeout(() => {
                        this.showPosterModal = false
                        this.getList()
                    }, 500)
                } else {
                    this.$message.error(resData.msg)
                }
            })
        },
        handlePosterClean() {
            this.showPosterModal = false
            const reqData = {
                id: this.detailItem.id,
                poster: "",
                poster_frame: null,
            }
            api.postCourseUpdatePosterInfo(reqData, (resData) => {
                if (resData.code === 0) {
                    this.$message.success("成功")
                    setTimeout(() => {
                        this.getList()
                    }, 500)
                } else {
                    this.$message.error(resData.msg)
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>

.st-list {
    margin-top: 35px;
    margin-bottom: 35px;
}

.st-list-item {
    margin-bottom: 32px;
}

.btn-new {
    //width: 102px;
    height: 32px;
    background: #333333;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 22px;
    float: right;
}

.mini-qrcode {
    margin-bottom: 16px;
}

.qrcode-btns {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.radio-sp {
    width: 1px;
    height: 16px;
    background-color: #EEEEEE;
    display: inline-block;
    margin-right: 24px;
    margin-left: 24px;
}

.list-demo-btn {
    margin-left: 32px;
    color: #FFAD00;
    line-height: 32px;
    font-size: 14px;
    cursor: pointer;
    cursor: pointer;
}
</style>